module.exports = __webpack_public_path__ + "static/media/instagram.68b33b91.svg";